export const COMPLIANCE_ACTIONS = {
  discard: {
    id: 'discard',
    label: 'label.DISCARD',
    bg: 'var(--color-red-300)',
    color: 'var(--color-white)',
    description: 'label.DESCRIPTION.COMPLIANCE_ACTIONS_DISCARD'
  },
  warn: {
    id: 'warn',
    label: 'label.WARNING_EMAIL',
    bg: 'var(--color-orange-400)',
    color: 'var(--color-white)',
    description: '',
    toggle: {
      collapsedText: 'label.MESSAGE.WARNING_EMAIL_SHOW',
      expandedText: 'label.MESSAGE.WARNING_EMAIL_HIDE'
    }
  },
  reject: {
    id: 'reject',
    label: 'label.REJECT',
    bg: 'var(--color-red-500)',
    color: 'var(--color-white)',
    description: 'label.DESCRIPTION.COMPLIANCE_ACTIONS_REJECT',
    toggle: {
      collapsedText: 'label.MESSAGE.REJECT_REASON_SHOW',
      expandedText: 'label.MESSAGE.REJECT_REASON_HIDE'
    }
  },
  disable_tracking: {
    id: 'disable_tracking',
    label: 'label.DISABLE_TRACKING',
    bg: 'var(--color-blue-500)',
    color: 'var(--color-white)',
    description: 'label.DESCRIPTION.COMPLIANCE_ACTIONS_DISABLE_TRACKING'
  },
  remove_trackers: {
    id: 'remove_trackers',
    label: 'label.REMOVE_TRACKERS',
    bg: 'var(--color-blue-400)',
    color: 'var(--color-white)',
    description: 'label.DESCRIPTION.COMPLIANCE_ACTIONS_REMOVE_TRACKERS'
  },
  modify_subject: {
    id: 'modify_subject',
    label: 'label.MODIFY_SUBJECT',
    bg: 'var(--color-yello-400)',
    color: 'var(--color-white)',
    description: 'label.DESCRIPTION.COMPLIANCE_ACTIONS_MODIFY_SUBJECT',
    toggle: {
      collapsedText: 'label.MESSAGE.MODIFIED_SUBJECT_SHOW',
      expandedText: 'label.MESSAGE.MODIFIED_SUBJECT_HIDE'
    }
  }
};

export const COMPLIANCE_ACTIONS_OPTIONS_FIELDS = {
  body: 'label.BODY',
  code: 'label.CODE',
  email: 'label.EMAIL',
  reason: 'label.REASON',
  subject: 'label.SUBJECT'
};
